import { RailwayAlertTwoTone } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import type React from "react";
import { useMemo } from "react";
import { Suspense, use } from "react";

import type { IFrameAssetsAdvertDtoPaginatedCollection } from "../../../../api/rest/generated/aPIForPublicPartOfApplicationInzerceNemovitéhoMajetku.schemas.ts";
import type { OverviewForm } from "../../../../hooks/useOverview.ts";
import AdvertisementItem from "./ItemPreview.tsx";
import { MoreResultsButton, type LoadMore } from "./MoreResultsButton.tsx";

interface ResultsListProps {
  resultsPromise: Promise<IFrameAssetsAdvertDtoPaginatedCollection>;
  resultsData: IFrameAssetsAdvertDtoPaginatedCollection | undefined;
  overviewForm: OverviewForm;
  isLoading: boolean;
}

export const ResultsList: React.FC<ResultsListProps> = ({
  resultsPromise,
  resultsData,
  overviewForm,
  isLoading,
}) => {

  // Show loader for results ...
  use(resultsPromise);

  const results = useMemo(() => resultsData?.data ?? [],[resultsData?.data]);

  if (results.length === 0) {
    return (
      <Box
        gap="1em"
        width="100%"
        justifyContent="center"
        alignItems="center"
        display="flex"
        flexDirection="column"
      >
        <Typography
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="15rem"
          color="primary"
          component="span"
        >
          <RailwayAlertTwoTone
            sx={{ fontSize: "inherit", marginRight: "-15%" }}
          />
        </Typography>
        <Typography variant="h1" color="primary" component="h3">
          Takové výsledky bohužel nemáme
        </Typography>
        <Typography variant="h3" color="textDisabled">
          zkuste vyhledat s jinými parametry
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      boxSizing="border-box"
      sx={{
        paddingX: "1em",
        // Define the container context here
        containerType: "inline-size",
        containerName: "main-layout",
      }}
    >
      {results.map((result) => (
        <Suspense key={result.id}>
          <AdvertisementItem data={result} />
        </Suspense>
      ))}
      <overviewForm.Field name="pageSize">
        {(fieldApi) => {
          const handleLoadMore = (props: LoadMore) => {
            fieldApi.setValue(props.pageSize);
            fieldApi.form.setFieldValue("page", props.page);
          };

          return (
            <Box
              display="flex"
              width="100%"
              boxSizing="border-box"
              padding="1em"
              alignItems="center"
              justifyContent="center"
            >
              <MoreResultsButton
                isLoading={isLoading}
                page={resultsData.page}
                renderedResults={results.length}
                loadMore={handleLoadMore}
                pageSize={resultsData.requestedPageSize}
                totalCount={resultsData.totalRecords}
              />
            </Box>
          );
        }}
      </overviewForm.Field>
    </Box>
  );
};

